import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../Navbar/Navbar";
import "./DailyUpdateApproval.css";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { bulkApproveDailyUpdate, empList } from "../../Redux/DailyUpdateApproval/Action";
import {
  dailyUpdateAdd,
  dailyUpdateList,
} from "../../Redux/DailyUpdate/Action";
import { FaEye } from "react-icons/fa";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import Swal from "sweetalert2";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Icon from "../utility/Icon";

const DailyUpdateApproval = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const { supportlists } = useSelector((store) => store.dailyUpdateApprover);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const { dailyUpdateDetails } = useSelector((store) => store.dailyUpdate);
  const [comment, setComment] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showApprovalInfo, setShowApprovalInfo] = useState(false);
  const handleCloseViewModal = () => setShowViewModal(false);
  const handleCloseCommentModal = () => setShowCommentModal(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState("");


  const [dailyUpdateData, setdailyUpdateData] = useState({
    dailyemployeeupdateId: "",
    date: "",
    inTime: "",
    outTime: "",
    name: "",
    todaytask: "",
    tomorrowtask: "",
    workdescription: "",
    createdDate: "",
    comment: "",
    remark: "",
    status: "",
    actionType: "list",
  });

  useEffect(() => {
    dispatch(empList(token, "SUP"));
  }, [dispatch, token]);

  const options = useMemo(
    () => [
      { value: 0, label: "ALL" }, // Static option
      ...supportlists.map((emp) => ({
        value: emp.loginId,
        label: `${emp.firstName} ${emp.lastName}`,
      })),
    ],
    [supportlists]
  );
  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  useEffect(() => {
    fetchData(pageNumber - 1, pageSize);
  }, [dispatch, fromDate, toDate, selectedEmployee, pageSize, pageNumber, searchText]);

  const fetchData = (pageNumber, pageSize) => {
    if (selectedEmployee) {
      const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      const formattedToDate = format(toDate, "yyyy-MM-dd");
      dispatch(
        dailyUpdateList(
          formattedFromDate,
          formattedToDate,
          selectedEmployee.value,
          token,
          pageSize,
          pageNumber,
          searchText
        )
      );
    }
  };


  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  useEffect(() => {
    if (dailyUpdateDetails.dailyEmployeeDetails && dailyUpdateDetails.dailyEmployeeDetails.length > 0) {
      setdailyUpdateData((prevData) => ({
        ...prevData,
        ...dailyUpdateDetails.dailyEmployeeDetails[0],
      }));

      const statusNotY = dailyUpdateDetails.dailyEmployeeDetails.some(
        emp => emp.status !== "Y"
      );

      setShowApprovalInfo(!statusNotY);

    }
  }, [dailyUpdateDetails]);



  const renderInOutTimes = (row) => (
    <div>
      <div>{row.inTime}</div>
      <div>{row.outTime}</div>
    </div>
  );

  const [selectedRow, setSelectedRow] = useState(null);
  const handleOpenViewModal = (row) => {
    setSelectedRow(row);
    setShowViewModal(true);
  };

  const handleOpenCommentModal = (row) => {
    setSelectedRow(row);
    setShowCommentModal(true);
  };

  const handleSubmit = (status) => {
    if (comment.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Comment is required",
        text: "Please enter a comment before submitting.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Add it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedRow = {
          dailyemployeeupdateId: selectedRow.dailyemployeeupdateid,
          status: status,
          actionType: "APPROVE",
          ...(status === "Y" && { remark: comment.trim(), comment: "" }),
          ...(status === "C" && { comment: comment.trim(), remark: "" }),
        };
        dispatch(dailyUpdateAdd(updatedRow, token))
          .then(({ success, error }) => {
            if (success) {
              const formattedFromDate = format(fromDate, "yyyy-MM-dd");
              const formattedToDate = format(toDate, "yyyy-MM-dd");
              dispatch(
                dailyUpdateList(
                  formattedFromDate,
                  formattedToDate,
                  selectedEmployee.value,
                  token,
                  pageSize,
                  pageNumber - 1
                )
              );
              handleCloseViewModal();
              setComment("");
              Swal.fire({
                icon: "success",
                title: status === "Y" ? "Approved!" : "Commented!",
                text: `Your ${status === "Y" ? "approval" : "comment"
                  } has been recorded.`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else if (error) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error || "Something went wrong!",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong during submission!",
            });
          });
      }
    });
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };
  const columns = [
    {
      name: "Date",
      selector: (row) => row.createdDate,
      sortable: true,
    },
    {
      name: "In/Out Time",
      selector: (row) => row,
      sortable: true,
      cell: renderInOutTimes,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row?.customerShortName || "",
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },

    {
      name: "Today's Task",
      selector: (row) => row.todaytask,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => {
        switch (row.status) {
          case "Y":
            return "Approved";
          case "N":
            return "Not Approved";
          case "C":
            return "Commented";
          default:
            return "Unknown Status";
        }
      },
      sortable: false,
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      cell: (row) => (
        <div>
          <Tooltip text="Add Comment">
            <Icon
              icon={BiSolidMessageRoundedDetail}
              variant="primary"
              onClick={() => handleOpenViewModal(row)}
            />
          </Tooltip>
          <Tooltip text="Overview">
            <Icon
              icon={FaEye}
              variant="secondary"
              className="ms-1"
              onClick={() => handleOpenCommentModal(row)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const bulkApprove = () => {

    if (showApprovalInfo) {
      Swal.fire({
        icon: "info",
        title: "Already Approved",
        text: "All the daily updates have been approved for the selected date range.",
        timer: 3000,
        showConfirmButton: false
      });
      return;

    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve all the daily updates?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) return;

      dispatch(bulkApproveDailyUpdate(format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd"), token))
        .then(({ success, error }) => {
          if (success) {
            fetchData(pageNumber - 1, pageSize);

            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Daily updates approved successfully.",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: error || "Something went wrong. Please try again later.",
            });
          }
        });
    });
  };


  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div>
            <div className="row mb-3">
              <div className="col-12 d-flex justify-content-md-end">
                <div className="filter-row d-flex flex-wrap">

                  <div className="filter-item d-flex align-items-center">
                    <b><label className="custom-label me-1">Employee:</label></b>
                    <div className="field-width">
                      <Select
                        options={options}
                        value={selectedEmployee}
                        onChange={handleEmpChange}
                        placeholder="Select Employee"
                        
                      />
                    </div>
                  </div>

                  <div className="filter-item d-flex align-items-center">
                    <b><label className="custom-label me-1">From:</label></b>
                    <div className="field-width">
                      <DatePicker
                        selected={fromDate}
                        onChange={(v) => setFromDate(v)}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </div>

                  <div className="filter-item d-flex align-items-center">
                    <b><label className="custom-label me-1">To:</label></b>
                    <div className="field-width">
                      <DatePicker
                        selected={toDate}
                        onChange={(v) => setToDate(v)}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(e) => e.preventDefault()}
                        minDate={fromDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>

          <div className="card3">
            <div className="card-body">

              <NewGlobalDataTable
                columns={columns}
                data={dailyUpdateDetails.dailyEmployeeDetails}
                tableName={'DAILY UPDATE APPROVALS'}
                setPageSize={setPageSize}
                setPageNumber={setPageNumber}
                totalRecord={dailyUpdateDetails.totalRecord}
                setFilterText={setSearchText}

              />
              {dailyUpdateDetails.totalRecord > 0 &&
                <div className="text-center">
                  <button type="button" onClick={bulkApprove} className="btn btn-success mt-3">
                    APPROVE ALL
                  </button>
                </div>
              }


              {/* First Modal: View Details */}
              {showViewModal && (
                <div
                  className="modal fade leave-modal show"
                  tabIndex="-1"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}

                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Update Comment</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleCloseViewModal}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="mb-3">
                            <label htmlFor="viewFormId" className="form-label">
                              <b>Comment:</b>
                            </label>
                            <textarea
                              id="viewFormId"
                              className="form-control textarea"
                              rows="5"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            />
                          </div>
                          <div className="d-flex justify-content-center mt-3 gap-3">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => handleSubmit("Y")}
                            >
                              APPROVE
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => handleSubmit("C")}
                            >
                              COMMENT
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Second Modal: Comment Details */}
              {showCommentModal && (
                <div
                  className="modal fade leave-modal show"
                  tabIndex="-1"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Comments/Remarks</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleCloseCommentModal}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        {selectedRow ? (
                          <div>
                            <div>
                              <strong>Work Description :</strong>{" "}
                              {selectedRow.todaytask ||
                                "No Description Added"}
                            </div>
                            <hr />
                            <div>
                              <strong>Comment :</strong>{" "}
                              {selectedRow.comment || "No Comment Added"}
                            </div>
                            <hr />
                            <div>
                              <strong>Remark :</strong>{" "}
                              {selectedRow.remark || "No Remark Added"}
                            </div>
                            <hr />
                          </div>
                        ) : (
                          <div>No Data Available</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyUpdateApproval;
